import { type EntityRef } from "@client/types";

export enum Actions {
  SetSelectedItem = "IMAGE_GALLERY_MODULE_SET_SELECTED_ITEM"
}

export type SetSelectedItemActionData = EntityRef & {
  itemId: string;
};
export const setSelectedItem = (ref: EntityRef, itemId: string) => ({
  type: Actions.SetSelectedItem,
  data: <SetSelectedItemActionData>{ ...ref, itemId }
});
